const openAsMobileTooltipModal = function () {
  const modal = $('#tooltipModal');
  const modalContainer = modal.find('.modal');
  const source = $(this).find('.info-box');
  const placeholder = modal.find('.placeholder');
  placeholder.html(source.html());
  const title = source.attr('data-title');
  if (title) { placeholder.prepend('<div class="title">' + title + '</div>'); }
  modal.removeClass('video-module');
  modal.addClass('visible');
  modalContainer.removeAttr('style');
};
const showSuroundingTooltip = function () {
  $(this).closest('.tooltip').addClass('tooltip--visible');
  $(this).closest('.tooltip').find('.info-box').removeClass('hidden');
};
const hideSuroundingTooltip = function () {
  $(this).closest('.tooltip').removeClass('tooltip--visible');
  $(this).closest('.tooltip').find('.info-box').addClass('hidden');
};
const tooltipClassicConfig = {
  name: 'tooltip',
  on: function () {
    $('.info-picto')
      .on('mouseenter', showSuroundingTooltip)
      .on('mouseleave', hideSuroundingTooltip)
      .each(hideSuroundingTooltip);
  },
  off: function () {
    $('.info-picto')
      .off('mouseenter', showSuroundingTooltip)
      .off('mouseleave', hideSuroundingTooltip);
  }
};
const tooltipModalConfig = {
  name: 'modal',
  on: function () { $('.tooltip').click(openAsMobileTooltipModal); },
  off: function () { $('.tooltip').off('click', openAsMobileTooltipModal); }
};
const tooltipConfigForCurrentMediaBreakpoint = function () {
  if ($(window).width() > 1024) {
    return tooltipClassicConfig;
  }
  return tooltipModalConfig;
};
document.addEventListener('DOMContentLoaded', function (event) {
  let config = tooltipConfigForCurrentMediaBreakpoint();
  config.on();
  $(window).on('resize', function ($event) {
    const newConfig = tooltipConfigForCurrentMediaBreakpoint();
    if (config.name == newConfig.name) { return; } // nothing changed
    config.off();
    config = newConfig;
    config.on();
  });
});
